/**
 * Admin · quién ha iniciado sesión.  (spec 058)
 */
import { useQuery } from '@tanstack/react-query'

import { useSesion } from '../../auth'
import { api } from '../../lib/api'
import { fechaHoraLarga } from '../../lib/tiempo'

interface Inicio {
    id: number
    email: string | null
    ip: string | null
    event: 'login_ok' | 'login_fail'
    at: string
}

export function etiquetaInicio(event: Inicio['event']): string {
    return event === 'login_ok' ? 'Entró' : 'No entró'
}

export function AccesosAdmin() {
    const { data: sesion } = useSesion()
    const q = useQuery<{ items: Inicio[] }>({
        queryKey: ['accesos'],
        queryFn: () => api.get<{ items: Inicio[] }>('/accesos'),
        enabled: sesion?.role === 'admin',
    })

    if (sesion && sesion.role !== 'admin') {
        return <p className="text-sm text-neutral-500">No encontrado</p>
    }

    const items = q.data?.items ?? []

    return (
        <div className="space-y-5 font-sans" data-testid="accesos-admin">
            <header>
                <h1 className="text-lg font-semibold text-neutral-100">Accesos</h1>
                <p className="mt-1 text-sm text-neutral-400">
                    Quién ha iniciado sesión: cuenta, cuándo y desde qué IP. Los
                    intentos que no entraron también.
                </p>
            </header>
            {q.isPending && <p className="text-sm text-neutral-500">Cargando…</p>}
            {q.isError && (
                <p className="text-sm text-rose-400">No se pudo leer el registro.</p>
            )}
            {q.data && items.length === 0 && (
                <p className="text-sm text-neutral-500">Nadie ha entrado todavía.</p>
            )}
            {items.length > 0 && (
                <div className="overflow-x-auto rounded-lg border border-neutral-800">
                    <table className="tabla-carta w-full border-collapse text-sm">
                        <thead>
                            <tr className="border-b border-neutral-800 text-left text-xs text-neutral-500">
                                <th className="px-3 py-2 font-medium">Cuenta</th>
                                <th className="px-3 py-2 font-medium">Cuándo</th>
                                <th className="px-3 py-2 font-medium">IP</th>
                                <th className="px-3 py-2 font-medium">Resultado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((i) => (
                                <tr
                                    key={i.id}
                                    className="border-b border-neutral-900 last:border-b-0"
                                    data-testid="fila-acceso"
                                    data-event={i.event}
                                >
                                    <td className="px-3 py-2 text-neutral-100" data-label="Cuenta">
                                        {i.email ?? <span className="text-neutral-600">—</span>}
                                    </td>
                                    <td
                                        className="whitespace-nowrap px-3 py-2 text-neutral-300"
                                        data-label="Cuándo"
                                    >
                                        {fechaHoraLarga(i.at)}
                                    </td>
                                    <td
                                        className="px-3 py-2 font-mono text-xs text-neutral-400"
                                        data-label="IP"
                                    >
                                        {i.ip ?? <span className="text-neutral-600">—</span>}
                                    </td>
                                    <td
                                        className={
                                            i.event === 'login_ok'
                                                ? 'px-3 py-2 text-emerald-400'
                                                : 'px-3 py-2 text-rose-400'
                                        }
                                        data-label="Resultado"
                                    >
                                        {etiquetaInicio(i.event)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    )
}
